const socialAuthPaths = new Set(
  [
    "google",
    "microsoft",
    "github",
    "jira",
    "clickup",
    "salesforce",
    "hubspot",
    "asana",
    "zoom",
    "linear",
    "rippling",
    "youtrack",
    "readai",
  ].map((provider) => `/sso/${provider}`),
);

export const isSocialAuthUrl = (url: string) => {
  const destination = new URL(url, window.location.origin);
  return (
    destination.origin === window.location.origin &&
    socialAuthPaths.has(destination.pathname)
  );
};

export const submitSocialAuth = (url: string, target = "_self") => {
  if (!isSocialAuthUrl(url)) {
    throw new Error("Social auth must start at a local provider endpoint");
  }
  const destination = new URL(url, window.location.origin);
  const form = document.createElement("form");
  form.method = "post";
  form.action = destination.pathname;
  form.target = target;
  form.hidden = true;
  // Put every option in the body: upstream reads `next` and invitation keys
  // from POST only. URLSearchParams preserves repeated and nested values.
  destination.searchParams.set("csrfmiddlewaretoken", window.TF.csrf);
  for (const [name, value] of destination.searchParams) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  try {
    // A parameter named "submit" must not shadow the native method.
    HTMLFormElement.prototype.submit.call(form);
  } finally {
    form.remove();
  }
};

export const openSocialAuthPopup = (
  url: string,
  name: string,
  features: string,
) => {
  const popup = window.open("about:blank", name, features);
  submitSocialAuth(url, popup ? name : "_self");
  return popup;
};
